export const MODULE_COMPARATIVE_ROUTE_NAME = 'school.module.comparative';
export const PRE_DASHBOARD_ROUTE_NAME = 'school.pre-dashboard';
export const MODULE_SCORE_COMPARATIVE_ROUTE_NAME = 'school.module.score';
export const MODULE_TIME_COMPARATIVE_ROUTE_NAME = 'school.module.time';
export const GROUP_MANAGE_STUDENTS_ROUTE_NAME = "school.group.add-student";
export const GROUP_MANAGE_TEACHERS_ROUTE_NAME = "school.class.register-teacher-class";
export const DASHBOARD_ROUTE_NAME = "school.home";
export const GROUPS_ROUTE_NAME = "school.group.index";
export const DOWNLOAD_ROUTE_NAME = "school.file.index";
export const STUDENT_PRESENCE_ROUTE_NAME = "school.student.presence";
export const STUDENT_TRAIL_ROUTE_NAME = "school.student.trails";
export const GRADE_ANALYSIS_ROUTE_NAME = "school.student.cycle.challenge.performance";
export const CONFIGS_CYCLE_ROUTE_NAME = "school.configs.cycle";
export const CONFIGS_TRAIL_ROUTE_NAME = "school.configs.trail";
export const STUDENT_ROUTE_NAME = "school.student.index";
export const CHALLENGE_APPLICATION_PERIOD_ROUTE_NAME = "school.challenge.application.period.index";
export const BOOKS_AND_CARDS_ROUTE_NAME = "school.books.and.cards.index";
export const CARD_UPLOADS_ROUTE_NAME = "school.card.uploads.index";
export const USER_CONFIG_ROUTE_NAME = "school.user.config";
export const CONFIG_MODULE_PERIOD_ROUTE_NAME = "school.module.period.config";
export const MODULES_QUANTITY_ROUTE_NAME = "school.module.qty.config";
export const SCORE_CALC_ROUTE_NAME = 'school.calc-score';
export const ACTIVITY_ROUTE_NAME = 'school.activity.index';
export const HOME_ROUTE_NAME = 'school.pre-dashboard';
export const PLAN_ROUTE_NAME = 'school.plan.index';
export const PAGE_NOT_FOUND = "page.not.found";
export const GENERAL_CONFIGS_ROUTE_NAME = 'school.general.configs'
export const APPLICATION_CONFIGS_ROUTE_NAME = 'school.application.configs'
export const RESULTS_ROUTE_NAME = 'school.results.index'
export const CHALLENGE_ROUTE_NAME = 'school.challenge.index'
export const PENDING_PLAN_ROUTE_NAME = 'school.plan.pending-confirmation'



export const MANAGER_ROUTES_FULL_VERSION = [
  DASHBOARD_ROUTE_NAME,
  HOME_ROUTE_NAME,
  DOWNLOAD_ROUTE_NAME,
  PAGE_NOT_FOUND,
  BOOKS_AND_CARDS_ROUTE_NAME,
  CARD_UPLOADS_ROUTE_NAME,
  GENERAL_CONFIGS_ROUTE_NAME,
  APPLICATION_CONFIGS_ROUTE_NAME,
  RESULTS_ROUTE_NAME,
  CHALLENGE_ROUTE_NAME,
  PENDING_PLAN_ROUTE_NAME,
  
  //rotas de análise de módulos
  MODULE_TIME_COMPARATIVE_ROUTE_NAME,
  STUDENT_PRESENCE_ROUTE_NAME,
  GRADE_ANALYSIS_ROUTE_NAME,
  MODULE_COMPARATIVE_ROUTE_NAME,
  MODULE_SCORE_COMPARATIVE_ROUTE_NAME,
  USER_CONFIG_ROUTE_NAME,
  SCORE_CALC_ROUTE_NAME,
  ACTIVITY_ROUTE_NAME,
  
  // rotas de gerenciamento
  PLAN_ROUTE_NAME,
  GROUP_MANAGE_TEACHERS_ROUTE_NAME,
  GROUP_MANAGE_STUDENTS_ROUTE_NAME,
  CONFIGS_TRAIL_ROUTE_NAME,
  STUDENT_TRAIL_ROUTE_NAME,
  CHALLENGE_APPLICATION_PERIOD_ROUTE_NAME,
  CONFIG_MODULE_PERIOD_ROUTE_NAME,
  MODULES_QUANTITY_ROUTE_NAME,
  
];

export const MANAGER_ROUTES_LITE_VERSION = [
  HOME_ROUTE_NAME,
  PLAN_ROUTE_NAME,
  PENDING_PLAN_ROUTE_NAME,
  BOOKS_AND_CARDS_ROUTE_NAME,
  CARD_UPLOADS_ROUTE_NAME,
  RESULTS_ROUTE_NAME,
];

export const TEACHER_ROUTES_FULL_VERSION = [
  DASHBOARD_ROUTE_NAME,
  HOME_ROUTE_NAME,
  DOWNLOAD_ROUTE_NAME,
  PAGE_NOT_FOUND,
  BOOKS_AND_CARDS_ROUTE_NAME,
  CARD_UPLOADS_ROUTE_NAME,
  STUDENT_ROUTE_NAME,
  RESULTS_ROUTE_NAME,
  PENDING_PLAN_ROUTE_NAME,

  //rotas de análise de módulos
  MODULE_TIME_COMPARATIVE_ROUTE_NAME,
  STUDENT_PRESENCE_ROUTE_NAME,
  GRADE_ANALYSIS_ROUTE_NAME,
  MODULE_COMPARATIVE_ROUTE_NAME,
  MODULE_SCORE_COMPARATIVE_ROUTE_NAME,
  USER_CONFIG_ROUTE_NAME,
  SCORE_CALC_ROUTE_NAME,
  ACTIVITY_ROUTE_NAME,

];


export const TEACHER_ROUTES_LITE_VERSION = [
  HOME_ROUTE_NAME,
  RESULTS_ROUTE_NAME,
  PENDING_PLAN_ROUTE_NAME,
];






